/**
 * Created by mzhao on 11/22/2022
 * Description:
 * DuplicateEvent Component
 * ------ maintenance history ------
 */
import { Component, OnDestroy, OnInit, ChangeDetectionStrategy, ChangeDetectorRef, Input, Output, EventEmitter } from '@angular/core';
import { Subscription } from 'rxjs';
import { ThreadDetailService } from '../../../services/thread-detail.service';
import { EntryType } from '@tamalelibs/models/entry-type.model';
import { DuplicateEventService } from './duplicate-event.service';

const date = 'date';
const isSelected = 'isSelected';

@Component({
    selector: 'tam-duplicate-event',
    templateUrl: './duplicate-event.component.html',
    styleUrls: ['./duplicate-event.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class DuplicateEventComponent implements OnInit, OnDestroy {
    @Output() updateEvent = new EventEmitter<string>();
    currentType: EntryType;
    data: Array<any> = [];
    //#region public properties
    date = '';
    opened = false;
    particpants = '';
    //#endregion

    //#region private properties

    /**
    * the subscription array that would be unsubscribed on destroying.
    */
    private _destroySubscriptions: Array<Subscription> = [];

    //#endregion

    constructor(private _changeDetectorRef: ChangeDetectorRef,
        private _threadDetailService: ThreadDetailService,
        private _duplicateEventService: DuplicateEventService,
    ) { }

    //#region public methods

    ngOnInit() {
        this._destroySubscriptions.push(
            this._duplicateEventService.dialogOpen$.subscribe(res => {
                this.data = res.data;
                this.currentType = res.currentType;
                this.data.forEach(item => {
                    item[date] = this._threadDetailService.getCalendarDateInfo(item.AllDay, item.displayDate, item.EndDate);
                });
                this.opened = true;
                this._changeDetectorRef.detectChanges();
            }));
    }

    ngOnDestroy(): void {
        this._destroySubscriptions.forEach(subscription => subscription.unsubscribe());
        this._destroySubscriptions = [];
    }

    clickEventItem(value) {
        this.data.forEach(item => {
            item[isSelected] = item === value;
        });
    }

    clickUpdateEvent(value) {
        this.data.forEach(item => {
            if (item[isSelected]) {
                this.updateEvent.emit(item.id);
                this.opened = false;
            }
        });
    }

    clickClose() {
        this.opened = false;
    }

    //#endregion

    //#region private methods

    //#endregion
}
